import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { View } from 'react-native';
import { Ratings } from '../../ui';

interface IProps {
    t: (key: string) => string;
    isReviewBodyExpanded: boolean;
    lastReviewDate: string;
    nutritionRating: number;
    toggleReviewSection(): void;
    onRatingPress(): void;
}

class UserNutritionReviewPopup extends Component<IProps, any> {
    render() {
        const {onRatingPress, nutritionRating } = this.props;

        return (
            <View>
                <Ratings input={{ onChange: onRatingPress, value: nutritionRating }} lightBackground />
            </View>
        );
    }
}


const UserNutritionReviewTranslate = translate(['nutrition'], { wait: true })(UserNutritionReviewPopup);
export default UserNutritionReviewTranslate;
